import * as React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { Divider, styled, Skeleton, useTheme } from '@mui/material';

const IconImgSkeleton = styled(Skeleton)(({ theme }) => ({
  width: theme.spacing(12),
  height: theme.spacing(12),
}));

const ListServicesSkeleton = styled(Box)(({ theme }) => ({
  marginLeft: theme.direction === 'ltr' ? theme.spacing(6) : '0',
  marginRight: theme.direction === 'rtl' ? theme.spacing(6) : '0',
  fontSize: theme.spacing(3.5),
  li: {
    marginBottom: theme.spacing(1),
  },
}));

const CustomCardSkeleton = styled(Card)(({ theme }) => ({
  minHeight: '276px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  padding: '33px 25px',
  borderRadius: '16px',
  border: `1px solid ${theme.palette.mode === 'dark' ? '#464646' : '#E5E5E5'}`,
  boxShadow: 'none',
  background: theme.palette.mode === 'dark' ? '#1E1E1E' : '#FFFFFF',
  backgroundImage: 'none',
}));

const ProductCategorySkeleton = () => {
  const theme = useTheme();
  return (
    <CustomCardSkeleton>
      <Box>
        <Box
          sx={{
            width: '48px',
            height: '48px',
            borderRadius: '12px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor:
              theme.palette.mode === 'dark' ? '#2A2A2A' : '#F5F5F5',
            marginBottom: '24px',
          }}
        >
          <Skeleton
            variant="rounded"
            width={24}
            height={24}
            sx={{ borderRadius: '4px' }}
          />
        </Box>
        <Skeleton
          width="60%"
          height={24}
          sx={{
            mb: '12px',
            borderRadius: '4px',
          }}
        />
        <Skeleton width="95%" height={16} sx={{ borderRadius: '4px' }} />
        <Skeleton
          width="85%"
          height={16}
          sx={{
            mb: '24px',
            borderRadius: '4px',
          }}
        />
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Skeleton width="100%" height={40} sx={{ borderRadius: '4px' }} />
        {/* <Skeleton 
          variant="circular" 
          width={20} 
          height={20} 
        /> */}
      </Box>
    </CustomCardSkeleton>
  );
};
export default ProductCategorySkeleton;
